import { Route, Redirect } from "react-router-dom";
import React, { Suspense, lazy, Fragment } from "react";
import Loader from "react-loaders";

import { ToastContainer } from "react-toastify";
import PrivateRoute from "./PrivateRoute";
import Login from "../../DemoPages/User/Login";

const Dashboards = lazy(() => import("../../DemoPages/Dashboards"));
const CampaignPerformance = lazy(() => import("../../DemoPages/CampaignPerformance"));
const CampaignTracker = lazy(()=> import("../../DemoPages/CampaignTracking"));
const AffiliatesTracking = lazy(()=> import("../../DemoPages/AffiliatesTracking"));
const Cohorts = lazy(()=> import("../../DemoPages/Cohorts"));
const CampaignInsights = lazy(()=> import("../../DemoPages/CampaignInsights"));
const ActiveUsers = lazy(()=> import("../../DemoPages/ActiveUsers"));
const DailyReport = lazy(()=> import("../../DemoPages/DailyReport"));
const GoogleAds = lazy(()=> import("../../DemoPages/GoogleAds"));
const PageConfig = lazy(()=> import("../../DemoPages/PageConfig"));
const OperatorAffiliate = lazy(()=> import("../../DemoPages/OperatorAffiliate"));
const Affiliate = lazy(()=> import("../../DemoPages/Affiliate"));
const Aggerator = lazy(()=> import("../../DemoPages/Aggerator"));
const InvestorPool = lazy(()=> import("../../DemoPages/InvestorPool"));
const Summary = lazy(()=> import("../../DemoPages/Summary"));
const LoanSummary = lazy(()=> import("../../DemoPages/LoanSummary"));
const GoogleCampaignTracking = lazy(()=> import("../../DemoPages/GoogleCampaignTracking"));
const SummaryBashboard = lazy(()=> import("../../DemoPages/SummaryDashboard"));
const RoadtoQatarDashboard = lazy(()=> import("../../DemoPages/RoadtoQatarDashboard"));
const UsersPoints = lazy(()=> import("../../DemoPages/UsersPoints"));
const LeaderBoard = lazy(()=> import("../../DemoPages/LeaderBoard"));

const AppMain = () => {
   const username = localStorage.getItem("username");
   const isUsername = username === "arab_cup"
    return (
        <Fragment>

            {/* Login */}
            <Suspense fallback={
                <div className="loader-container">
                    <div className="loader-container-inner">
                        <div className="text-center">
                            <Loader type="ball-grid-cy"/>
                        </div>
                        <h6 className="mt-3">
                            Please wait ...
                        </h6>
                    </div>
                </div>
            }>
                <PrivateRoute path="/Login" component={Login} />
            </Suspense>

            {/* Dashboards */}
            <Suspense fallback={
                <div className="loader-container">
                    <div className="loader-container-inner">
                        <div className="text-center">
                            <Loader type="ball-grid-cy"/>
                        </div>
                        <h6 className="mt-3">
                           Please wait while we load all the Dashboards
                        </h6>
                    </div>
                </div>
            }>
                <PrivateRoute path="/dashboards" component={Dashboards} />
            </Suspense>

            {/* CampaignPerformance */}
            <Suspense fallback={
                <div className="loader-container">
                    <div className="loader-container-inner">
                        <div className="text-center">
                            <Loader type="ball-grid-cy"/>
                        </div>
                        <h6 className="mt-3">
                           Please wait while we load all the Campaign Performance
                        </h6>
                    </div>
                </div>
            }>
                <PrivateRoute path="/campaignperformance" component={CampaignPerformance} />
            </Suspense>

            {/* Active users */}
            <Suspense fallback={
                <div className="loader-container">
                    <div className="loader-container-inner">
                        <div className="text-center">
                            <Loader type="ball-grid-cy"/>
                        </div>
                        <h6 className="mt-3">
                           Please wait while we load all the Active Users
                        </h6>
                    </div>
                </div>
            }>
                <PrivateRoute path="/activeusers" component={ActiveUsers} />
            </Suspense>

             {/* DailyReport */}
             <Suspense fallback={
                <div className="loader-container">
                    <div className="loader-container-inner">
                        <div className="text-center">
                            <Loader type="ball-grid-cy"/>
                        </div>
                        <h6 className="mt-3">
                           Please wait while we load all the DailyReport
                        </h6>
                    </div>
                </div>
            }>
                <PrivateRoute path="/dailyreport" component={DailyReport} />
            </Suspense>

            {/* Campaign Tracking */}
            <Suspense fallback={
                <div className="loader-container">
                    <div className="loader-container-inner">
                        <div className="text-center">
                            <Loader type="ball-grid-cy"/>
                        </div>
                        <h6 className="mt-3">
                           Please wait while we load all the CampaignTracker
                        </h6>
                    </div>
                </div>
            }>
                <PrivateRoute path="/campaigntracker" component={CampaignTracker} />
            </Suspense>

            {/* Affiliates Tracking */}
            <Suspense fallback={
                <div className="loader-container">
                    <div className="loader-container-inner">
                        <div className="text-center">
                            <Loader type="ball-grid-cy"/>
                        </div>
                        <h6 className="mt-3">
                           Please wait while we load all the Affiliates Tracking
                        </h6>
                    </div>
                </div>
            }>
                <PrivateRoute path="/affiliatestracking" component={AffiliatesTracking} />
            </Suspense>

            {/* Cohorts Tracking */}
            <Suspense fallback={
                <div className="loader-container">
                    <div className="loader-container-inner">
                        <div className="text-center">
                            <Loader type="ball-grid-cy"/>
                        </div>
                        <h6 className="mt-3">
                           Please wait while we load all the Affiliates Tracking
                        </h6>
                    </div>
                </div>
            }>
                <PrivateRoute path="/metricstracker" component={Cohorts} />
            </Suspense>

            {/* CampaignInsights */}
            <Suspense fallback={
                <div className="loader-container">
                    <div className="loader-container-inner">
                        <div className="text-center">
                            <Loader type="ball-grid-cy"/>
                        </div>
                        <h6 className="mt-3">
                           Please wait while we load all the Campaign Insights
                        </h6>
                    </div>
                </div>
            }>
                <PrivateRoute path="/campaigninsights" component={CampaignInsights} />
            </Suspense>


            {/* Google ads*/}
            <Suspense fallback={
                <div className="loader-container">
                    <div className="loader-container-inner">
                        <div className="text-center">
                            <Loader type="ball-grid-cy"/>
                        </div>
                        <h6 className="mt-3">
                           Please wait while we load all the Google Ads
                        </h6>
                    </div>
                </div>
            }>
                <PrivateRoute path="/googleads" component={GoogleAds} />
            </Suspense>

            {/* OperatorAffiliate*/}
            <Suspense fallback={
                <div className="loader-container">
                    <div className="loader-container-inner">
                        <div className="text-center">
                            <Loader type="ball-grid-cy"/>
                        </div>
                        <h6 className="mt-3">
                           Please wait while we load all the Operator Affiliate
                        </h6>
                    </div>
                </div>
            }>
                <PrivateRoute path="/operatoraffiliate" component={OperatorAffiliate} />
            </Suspense>

            {/*Affiliate*/}
            <Suspense fallback={
                <div className="loader-container">
                    <div className="loader-container-inner">
                        <div className="text-center">
                            <Loader type="ball-grid-cy"/>
                        </div>
                        <h6 className="mt-3">
                           Please wait while we load all the Affiliate
                        </h6>
                    </div>
                </div>
            }>
                <PrivateRoute path="/affiliate" component={Affiliate} />
            </Suspense>

            {/*Aggerator*/}
            <Suspense fallback={
                <div className="loader-container">
                    <div className="loader-container-inner">
                        <div className="text-center">
                            <Loader type="ball-grid-cy"/>
                        </div>
                        <h6 className="mt-3">
                           Please wait while we load all the Aggerator
                        </h6>
                    </div>
                </div>
            }>
                <PrivateRoute path="/aggerator" component={Aggerator} />
            </Suspense>

            {/* PageConfig*/}
            <Suspense fallback={
                <div className="loader-container">
                    <div className="loader-container-inner">
                        <div className="text-center">
                            <Loader type="ball-grid-cy"/>
                        </div>
                        <h6 className="mt-3">
                           Please wait while we load all the Page Configurations
                        </h6>
                    </div>
                </div>
            }>
                <PrivateRoute path="/pageconfig" component={PageConfig} />
            </Suspense>

            {/*InvestorPool*/}
            <Suspense fallback={
                <div className="loader-container">
                    <div className="loader-container-inner">
                        <div className="text-center">
                            <Loader type="ball-grid-cy"/>
                        </div>
                        <h6 className="mt-3">
                           Please wait while we load all the InvestorPool
                        </h6>
                    </div>
                </div>
            }>
                <PrivateRoute path="/investorpool" component={InvestorPool} />
            </Suspense>

            {/*Summary*/}
            <Suspense fallback={
                <div className="loader-container">
                    <div className="loader-container-inner">
                        <div className="text-center">
                            <Loader type="ball-grid-cy"/>
                        </div>
                        <h6 className="mt-3">
                           Please wait while we load all the Summary
                        </h6>
                    </div>
                </div>
            }>
                <PrivateRoute path="/summary" component={Summary} />
            </Suspense>

            {/*laon Summary*/}
            <Suspense fallback={
                <div className="loader-container">
                    <div className="loader-container-inner">
                        <div className="text-center">
                            <Loader type="ball-grid-cy"/>
                        </div>
                        <h6 className="mt-3">
                           Please wait while we load all the LoanSummary
                        </h6>
                    </div>
                </div>
            }>
                <PrivateRoute path="/loansummary" component={LoanSummary} />
            </Suspense>

            {/*laon Summary*/}
            <Suspense fallback={
                <div className="loader-container">
                    <div className="loader-container-inner">
                        <div className="text-center">
                            <Loader type="ball-grid-cy"/>
                        </div>
                        <h6 className="mt-3">
                           Please wait while we load all the Summary Dashboard
                        </h6>
                    </div>
                </div>
            }>
                <PrivateRoute path="/summarydashboard" component={SummaryBashboard} />
            </Suspense>
            
            {/*Google Campaign Tracking*/}
            <Suspense fallback={
                <div className="loader-container">
                    <div className="loader-container-inner">
                        <div className="text-center">
                            <Loader type="ball-grid-cy"/>
                        </div>
                        <h6 className="mt-3">
                           Please wait while we load all the GoogleCampaignTracking
                        </h6>
                    </div>
                </div>
            }>
                <PrivateRoute path="/googlecampaigntracking" component={GoogleCampaignTracking} />
            </Suspense>

            {/*road to qatar dashborad*/}
            <Suspense fallback={
                <div className="loader-container">
                    <div className="loader-container-inner">
                        <div className="text-center">
                            <Loader type="ball-grid-cy"/>
                        </div>
                        <h6 className="mt-3">
                           Please wait while we load all Dashboard
                        </h6>
                    </div>
                </div>
            }>
                <PrivateRoute path="/roadtoqatardashboardd" component={RoadtoQatarDashboard} />
            </Suspense>

            {/*road to qatar users points*/}
            <Suspense fallback={
                <div className="loader-container">
                    <div className="loader-container-inner">
                        <div className="text-center">
                            <Loader type="ball-grid-cy"/>
                        </div>
                        <h6 className="mt-3">
                           Please wait while we load all Users Points
                        </h6>
                    </div>
                </div>
            }>
                <PrivateRoute path="/roadtoqatarpoints" component={UsersPoints} />
            </Suspense>

            {/*road to qatar leaderboard*/}
            <Suspense fallback={
                <div className="loader-container">
                    <div className="loader-container-inner">
                        <div className="text-center">
                            <Loader type="ball-grid-cy"/>
                        </div>
                        <h6 className="mt-3">
                           Please wait while we load all LeaderBoard
                        </h6>
                    </div>
                </div>
            }>
                <PrivateRoute path="/roadtoqatarleaderboard" component={LeaderBoard} />
            </Suspense>

            <Route exact path="/" render={() => (
                localStorage.getItem("auth") ? isUsername ? <Redirect to="/roadtoqatardashboardd" /> : <Redirect to="/dashboards" /> : < Redirect to="/login" />
            )} />

            <ToastContainer/>
        </Fragment>
    )
};

export default AppMain;
